import { Headline } from '@velocity/ui';
import React from 'react';

interface FormSectionProps extends Omit<
  React.HTMLAttributes<HTMLElement>,
  'title'
> {
  /** Section headline (Figma: headline-200, e.g. "Persönliche Daten") */
  title?: React.ReactNode;
  /** Optional copy rendered under the headline */
  subtitle?: React.ReactNode;
}

/*
 * Shared card wrapper for every B2B / B2C form section
 * (Figma: Instant Lease - B2C, node 467:4250 → "Rectangle 1296/1299").
 * White card, 1px secondary-100 border, 16px radius, 24px padding and a
 * 24px vertical rhythm between fields.
 */
const FormSection: React.FC<FormSectionProps> = ({
  title,
  subtitle,
  children,
  className = '',
  ...props
}) => (
  <section
    className={`flex w-full flex-col gap-6 rounded-2xl border border-(--vel-color-secondary-100) bg-white p-6 ${className}`}
    {...props}
  >
    {(title || subtitle) && (
      <div className='flex flex-col gap-2'>
        {title && (
          <Headline
            variant='200'
            component='h2'
            data-testid='form-section-title'
            className='text-(--vel-color-secondary-400)!'
          >
            {title}
          </Headline>
        )}
        {subtitle && (
          <p className='text-body-loose-200 text-(--vel-color-neutral-700)'>
            {subtitle}
          </p>
        )}
      </div>
    )}
    {children}
  </section>
);

export default FormSection;
